module.exports = {"350605100":"武安镇","350605101":"岩溪镇","350605102":"陈巷镇","350605103":"枋洋镇","350605200":"坂里乡","350605400":"国营古农农场","350605500":"长泰经济开发区","350605501":"马洋溪生态旅游区","350605502":"林墩工业区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350605.json
// module id = 1322
// module chunks = 0